import { Component } from '@angular/core';
import { dummyStory, Story } from '../../../shared/interfaces/story';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';
import { AuthService } from '../../../core/services/auth.service';
import { ConsoleLoggerService } from '../../../core/services/console-logger.service';
import { PublishDialogComponent } from './publish-dialog/publish-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { StoryService } from '../../../shared/services/story.service';
import { SlugifyPipe } from '../../../shared/pipes/slugify.pipe';
import { nav_path } from '../../../app-routing.module';
import { FirestoreService } from '../../../shared/services/firestore.service';
import { SeoService } from '../../../core/services/seo.service';
import { RemoveStoryTitlePipe } from '../../../shared/pipes/remove-story-title.pipe';

@Component({
  selector: 'anon-new-story',
  templateUrl: './new-story.component.html',
  styleUrls: ['./new-story.component.scss']
})
export class NewStoryComponent {
  public readonly nav_path = nav_path;
  public isLoading = true;
  public story: Story = {...dummyStory};
  storyCharacterCount: number = 0;
  storyWordCount: number = 0;
  editorConfig = {
    placeholder: 'Tell your story...',
    wordCount: {
      onUpdate: (stats:any) => {
        this.storyCharacterCount = stats.characters;
        this.storyWordCount = stats.words;
      },
    },
  };
  private title = "New story page";

  constructor(
    private storyService: StoryService,
    private cLog: ConsoleLoggerService,
    private auth: AuthService,
    private dialog: MatDialog,
    private slugify: SlugifyPipe,
    private db: FirestoreService,
    private seo: SeoService,
    public rst: RemoveStoryTitlePipe
  ) {
    seo.generateTags({
    title: this.title,
    description: `Anonymous Systems ${this.title}`,
    route: nav_path.newStory
  });
    setTimeout(() => this.isLoading = false, 500);
  }

  public onChange({editor}: ChangeEvent) {
    if (editor) {
      this.storyService.parseEditorContent(editor, this.story);
      this.storyService.calculateStoryReadTime(this.story, this.storyWordCount);
    }
  }

  previewStory(event: boolean) {
    const story = this.story;
    let user = this.auth.user;
    story.roles = {[user!.uid]: "owner"};
    story.author = {
      name: user?.displayName!,
      image: user?.photoURL!
    };
    story.user = this.db.doc(`users/${this.auth.user?.uid}`);

    if (story.roles && Object.keys(story.roles).length < 0) {
      this.cLog.error('Error: Story has no roles assigned');
      return;
    }
    if (!story.title) {
      this.cLog.error('Error: Story has no title');
      return;
    } else {
      story.slug = this.slugify.transform(story.title);
    }
    if (!this.rst.transform(story.content)) {
      this.cLog.error('Error: Story has no content');
      return;
    }

    this.dialog.open(PublishDialogComponent, {
      id: 'publish-dialog',
      data: {story: story},
      panelClass: 'publish-dialog-container',
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw'
    });
  }
}
